import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography } from '@material-ui/core';
import * as React from 'react';
import DialogTitle from 'v2/components/Shared/DialogTitle';

import { useStyles } from './styles';

type PermanentAccessAlertModalProps = {
  isOpen: boolean;
  handleClose: () => void;
};

const PermanentAccessAlertModal = ({ isOpen, handleClose }: PermanentAccessAlertModalProps) => {
  const classes = useStyles();

  return (
    <Dialog open={isOpen} onClose={() => handleClose()} maxWidth='xs'>
      <DialogTitle onClose={() => handleClose()}>
        <Typography className={classes.title}>
          <img src='/img/alert-icon.svg' width='25' /> <span>Acesso permanente</span>
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.dialogContentContainer}>
          <Typography variant='subtitle1' color='textPrimary'>
            Ativar o acesso permanente garante que o cliente continue com acesso
            <span className={classes.bold}> mesmo após o fim do contrato.</span>
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.buttonActionsContainer}>
        <Button onClick={() => handleClose()} color='primary' size='medium' variant='contained'>
          Entendi
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PermanentAccessAlertModal;
